import React from 'react';
import { LanguageContext } from '../../utilities/LocalizationModule';
import { useNavigate } from 'react-router-dom';
import {
	Panel,
	Label,
	Stack,
	PrimaryButton,
	TextField,
	Persona,
	PersonaSize,
	DefaultButton,
	Toggle,
	CommandBarButton,
	IColumn,
	PanelType,
	FontWeights,
	Dropdown,
	ScrollablePane,
	ScrollbarVisibility,
	mergeStyles,
	IPanelStyles,
	MessageBar,
	MessageBarType,
	Link,
	Image,
	IButtonStyles,
	Spinner,
	SpinnerSize,
	Icon,
} from '@fluentui/react';
import { IAdminStatusUpdate, IPortalPartner, ITenant, ITenantContextUsage, ITenantPartner, ITenantUser, TenantListPanels } from '../../data-structures/interfaces';
import { dropdownStyles, labelHeadingStyle, labelInfoStyle, panelActionButtonStyle } from '../../styles/PanelStyle';
import { connect, ConnectedProps } from 'react-redux';
import { RootState } from '../../redux';
import { updateUser, assignTenants, removeTenants, updateAdminStatus, addTenant, getTenantSites, getSiteLibraries } from '../../redux/modules/user';
import { v4 as uuidv4 } from 'uuid';
import ViewListPanel from './ViewListPanel';
import OrderedFieldsPanel from './OrderedFieldsPanel';
import { DefaultChannelTabLocation, LandingPage, PanelReturnType, ScopeType, SubscriptionStatusEnum, TenantListSections } from '../../data-structures/enums';
import { templateAiCapabilities, templateAiCrmKeyToStoredId, templateAiCrmOptions, templateAiSectionState, templateAiSelectedCrmKey } from '../../utilities/helpers/templateAiSectionState';
import ListToggleSection from '../ListToggleSection';
import ManageSitesPanel from './ManageSitesPanel';
import DataSourcePanel from './DataSourcePanel';
import ApiKeyItem from '../../_v2/components/FormItems/ApiKeyItem';
import { lang } from 'moment';
import { EmailMappingPanel } from './EmailMappingPanel';
import { addTenantAPI, assignTenantsAPI, clearTenantUserEmailMappings, getPartners, getTenantContextUsage, getTenantSubscriptions, getTenantTemplateAiSettings, ITenantTemplateAiSettings, removeTenantsAPI } from '../../utilities/helpers/ApiHelper';
import ColorPickerPanel from './ColorPickerPanel';
import { ErrorHelper } from '../../utilities/helpers/ErrorHelper';
import { SecuredInput } from '../../_v2/components/FormItems/SecuredInput';
import InfoBox from '../InfoBox';
import { WriteOnlySecretInput } from '../../_v2/components/FormItems/WriteOnlySecretInput';
import { StorageHelper } from '../../utilities/helpers/StorageHelper';

const DOCUBIRD_LOGO: string = "data:image/svg+xml;base64,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";

const initList: TenantListPanels[] = [
	{
		isOpen: false,
		type: TenantListSections.AdvancedSearch,
	},
	{
		isOpen: false,
		type: TenantListSections.MetaData,
	},
	{
		isOpen: false,
		type: TenantListSections.Sites,
	},
	{
		isOpen: false,
		type: TenantListSections.Teams,
	},
	{
		isOpen: false,
		type: TenantListSections.ColorPicker
	}
];

const sectionSeparator: React.CSSProperties = {
	borderTop: '1px solid var(--db-border)',
	paddingTop: 10,
};

export const panelStyle: Partial<IPanelStyles> = {
	content: { paddingLeft: 25, paddingRight: 5 },
};

export const scrollStyle = mergeStyles({
	position: 'relative',
	height: 'calc(100vh - 140px)',
	marginTop: 5,
});

const contextUsageListStyle = mergeStyles({
	display: 'flex',
	flexDirection: 'column',
	gap: 8,
	marginTop: 6,
});

const contextUsageRowStyle = mergeStyles({
	backgroundColor: 'var(--db-surface-raised)',
	border: '1px solid var(--db-border)',
	borderRadius: 8,
	boxSizing: 'border-box',
	padding: '10px 12px',
	boxShadow: '0 1px 2px rgba(0, 0, 0, 0.04)',
});

const contextUsageRowHeaderStyle = mergeStyles({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'space-between',
	gap: 12,
});

const contextUsageNameStyle = mergeStyles({
	color: 'var(--db-fg)',
	fontSize: 14,
	fontWeight: FontWeights.semibold,
	minWidth: 0,
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	whiteSpace: 'nowrap',
});

const contextUsageCountStyle = mergeStyles({
	alignItems: 'center',
	backgroundColor: 'var(--db-pill-info-bg)',
	border: '1px solid var(--db-pill-info-border)',
	borderRadius: 8,
	color: 'var(--db-pill-info-fg)',
	display: 'inline-flex',
	flexShrink: 0,
	fontSize: 12,
	fontWeight: FontWeights.semibold,
	justifyContent: 'center',
	minWidth: 28,
	padding: '2px 2px',
});

const contextUsageBarTrackStyle = mergeStyles({
	backgroundColor: 'var(--db-border)',
	borderRadius: 8,
	height: 5,
	marginTop: 8,
	overflow: 'hidden',
});

const contextUsageBarFillStyle = mergeStyles({
	backgroundColor: 'var(--db-accent)',
	borderRadius: 8,
	height: '100%',
	transition: 'width 200ms ease',
});

const contextUsageEmptyStateStyle = mergeStyles({
	backgroundColor: 'var(--db-surface)',
	border: '1px solid var(--db-border)',
	borderRadius: 8,
	boxSizing: 'border-box',
	color: 'var(--db-fg-muted)',
	fontSize: 14,
	marginTop: 6,
	padding: '10px 12px',
});

const ocrLanguageDropDownOptions = [
	{ key: '', text: '' },
	{ key: 'bel', text: 'Belgian' },
	{ key: 'chi_sim', text: 'Chinese' },
	{ key: 'nld', text: 'Dutch' },
	{ key: 'eng', text: 'English' },
	{ key: 'fra', text: 'French' },
	{ key: 'deu', text: 'German' },
	{ key: 'ita', text: 'Italian' },
	{ key: 'jpn', text: 'Japanese' },
	{ key: 'pol', text: 'Polish' },
	{ key: 'rus', text: 'Russian' },
	{ key: 'spa', text: 'Spanish' },
];

const newTemplateTypesDropDownOptions = [
	{ key: 'bel', text: lang },
	{ key: 'chi_sim', text: 'Chinese' },
	{ key: 'nld', text: 'Dutch' },
	{ key: 'eng', text: 'English' },
	{ key: 'fra', text: 'French' },
	{ key: 'deu', text: 'German' },
	{ key: 'ita', text: 'Italian' },
	{ key: 'jpn', text: 'Japanese' },
	{ key: 'pol', text: 'Polish' },
	{ key: 'rus', text: 'Russian' },
	{ key: 'spa', text: 'Spanish' },
];

const consentButtonStyles: IButtonStyles = {
	root: {
		width: 250
	}
}

const getTenantContextUsageCacheKey = (tenantId: number): string => `TenantContextUsage_${tenantId}`;

const mapStateToProps = (state: RootState) => {
	return {
		partnerId: state.user.id,
		isPartner: state.user.isPartner,
		isGlobalAdmin: state.user.isGlobalAdmin,
		isTenantAdmin: state.user.isTenantAdmin,
		users: state.user.users,
		isLoading: state.user.isUserLoading,
	};
};

const mapDispatchToProps = {
	updateUser,
	assignTenants,
	removeTenants,
	updateAdminStatus,
	addTenant,
	getTenantSites,
	getSiteLibraries
};

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

interface EditTenantPanelProps extends PropsFromRedux {
	isOpen: boolean;
	setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
	setShowDeleteDialog: React.Dispatch<React.SetStateAction<boolean>>;
	setShowGlobalDeleteDialog: React.Dispatch<React.SetStateAction<boolean>>;
	tenant: ITenant;
	tenantUsers: ITenantUser[];
	updateTenant: (newTenant: ITenant, oldItem: ITenant) => void;
	validateName: (value: string) => string;
	closeOnAddSuccess: () => void;
}

const EditTenantPanel: React.FC<EditTenantPanelProps> = ({
	isOpen,
	setIsOpen,
	tenant,
	tenantUsers,
	validateName,
	updateTenant,
	setShowDeleteDialog,
	setShowGlobalDeleteDialog,
	isPartner,
	isGlobalAdmin,
	isTenantAdmin,
	users,
	assignTenants,
	removeTenants,
	updateAdminStatus,
	closeOnAddSuccess,
	isLoading,
	addTenant,
	getTenantSites,
	getSiteLibraries
}: EditTenantPanelProps) => {
	const languageStrings = React.useContext(LanguageContext);
	const navigate = useNavigate();
	const [originalItem, setOriginalItem] = React.useState<ITenant>(null);
	const [isSaveDisabled, setIsSaveDisabled] = React.useState<boolean>(true);
	const [newTenant, setNewTenant] = React.useState<ITenant>(null);
	const [isPartnerViewListOpen, setIsPartnerViewListOpen] = React.useState(false);
	const [isAdminViewListOpen, setIsAdminViewListOpen] = React.useState(false);
	const [newPartner, setNewPartner] = React.useState<ITenantPartner[]>([tenant?.partner]);
	const [newTenantAdmins, setNewTenantAdmins] = React.useState<ITenantUser[]>(tenantUsers.filter((u) => u.isTenantAdmin));
	const [returnType, setReturnType] = React.useState<PanelReturnType>(null);
	const [tenantListPanels, setTenantListPanels] = React.useState<TenantListPanels[]>(initList);
	const [isManageSitesOpen, setIsManageSitesOpen] = React.useState<boolean>(false);
	// GATING METADATA only - can the server run the feature, does this tenant own a template
	// library, which CRM datasources does the picker offer. The two EDITABLE settings are
	// ordinary fields on newTenant (templateAiEnabled / templateAiCrmDatasourceId) and save
	// through Tenant/Update with everything else, so nothing here is a draft and nothing here
	// needs a baseline. undefined = not loaded yet, or the load failed: controls stay disabled.
	const [templateAiMeta, setTemplateAiMeta] = React.useState<ITenantTemplateAiSettings | undefined>(undefined);
	React.useEffect(() => {
		let cancelled = false;
		setTemplateAiMeta(undefined);
		if (tenant?.id > 0) {
			getTenantTemplateAiSettings(tenant.id).then(meta => { if (!cancelled) setTemplateAiMeta(meta); });
		} else {
			// A tenant that does not exist yet has nothing to read. Every gate here fails
			// CLOSED; templateAiSectionState short-circuits on isUnsavedTenant anyway, so
			// these values only have to be safe, not accurate.
			setTemplateAiMeta({
				hasTemplateDatasource: false, featureAvailable: false,
				featureDisabledReason: null, crmDatasources: [],
			});
		}
		return () => { cancelled = true; };
	}, [tenant?.id]);

	// Eligibility and the picker's options both ride on the settings response above, so the
	// section gates itself without a second request. They deliberately do NOT come from
	// tenant.datasources: that array is lazy-loaded only when the Datasources panel opens, so
	// reading it here left the picker invisible on a fresh tenant-panel open.
	// The enabled flag comes from the DRAFT tenant, not the metadata: switching the toggle on
	// has to reveal the picker immediately, not after a save and a refetch.
	// The fourth argument is the opposite: the SAVED flag, so switching the toggle off cannot
	// take the escape-hatch section - and with it the only control for the flag - off screen.
	const aiSection = templateAiSectionState(
		templateAiMeta, !(newTenant?.id > 0), newTenant?.templateAiEnabled === true,
		// The flag as this panel OPENED it - `tenant`, never `newTenant`. It holds both escape
		// hatches open for the whole editing session, so following the warning's advice cannot
		// delete the toggle that gave it. Fixed for the panel's lifetime, so no state and no
		// effect: Save closes the panel (see the Save button's onClick), which is why the prop
		// never refreshes underneath an open panel and the section cannot vanish mid-edit.
		tenant?.templateAiEnabled === true);
	const [isDataSourcePanelOpen, setIsDataSourcePanelOpen] = React.useState<boolean>(false);
	const [isColorPickerPanelOpen, setIsColorPickerPanelOpen] = React.useState<boolean>(false);
	// const [isSelectPiiInfoTypesPanelOpen, setIsSelectPiiInfoTypesPanelOpen] = React.useState<boolean>(false);
	const [isEmailMappingPanelOpen, setIsEmailMappingPanelOpen] = React.useState<boolean>(false);
	const [errorMessage, setErrorMessage] = React.useState<string>("");
	const [partners, setPartners] = React.useState<IPortalPartner[]>([]);
	const [subscriptionCount, setSubscriptionCount] = React.useState(0);
	const [tenantSiteLibrariesCount, setTenantSiteLibrariesCount] = React.useState<number>(0);
	const [tenantSiteLibrariesLoaded, setTenantSiteLibrariesLoaded] = React.useState<boolean>(false);
	const [tenantContextUsage, setTenantContextUsage] = React.useState<ITenantContextUsage[] | null>(null);
	const [isTenantContextUsageLoading, setIsTenantContextUsageLoading] = React.useState<boolean>(false);

	const fileUploadInput = React.useRef<HTMLInputElement>(null);

	const [newTemplateTypesDropDownOptions] = React.useState([
		{ key: 'folder', text: languageStrings.Folder },
		{ key: 'docset', text: languageStrings.DocumentSet },
		{ key: 'file', text: languageStrings.File },
	]);

	React.useEffect(() => {
		(async () => {
			setPartners(await getPartners());
		})();
	}, []);

	React.useEffect(() => {
		if (isOpen == true) {
			(async () => {
				const originalTenant: ITenant = {
					...tenant,
					showAllAdvancedSearchFields: checkIfAllFields(tenant, TenantListSections.AdvancedSearch),
					showAllMetaDataFields: checkIfAllFields(tenant, TenantListSections.MetaData),
					showAllSites: checkIfAllFields(tenant, TenantListSections.Sites),
					showAllTeams: checkIfAllFields(tenant, TenantListSections.Teams),
					tessIsEnabled: tenant?.tessUrl?.length > 0 || tenant?.tessClientId?.length > 0 || tenant?.tessClientSecret?.length > 0 || tenant?.tessClientSecretMasked?.length > 0,
					clientListIsEnabled: tenant?.clientListUrl?.trim()?.length > 0,
					key: uuidv4(),
				};
				setOriginalItem(originalTenant);
				setNewTenant({
					...tenant,
					showAllAdvancedSearchFields: originalTenant.showAllAdvancedSearchFields,
					showAllMetaDataFields: originalTenant.showAllMetaDataFields,
					showAllSites: originalTenant.showAllSites,
					showAllTeams: originalTenant.showAllTeams,
					tessIsEnabled: originalTenant.tessIsEnabled,
					clientListIsEnabled: originalTenant.clientListIsEnabled,
					landingPage: !originalTenant.tessIsEnabled && originalTenant.landingPage === LandingPage.Tess
						? LandingPage.Default
						: originalTenant.landingPage
				});

				if (isGlobalAdmin && originalTenant.id > 0) {
					await loadTenantContextUsage(originalTenant.id);
				} else {
					setTenantContextUsage([]);
					setIsTenantContextUsageLoading(false);
				}

				const subscriptionsRes = await getTenantSubscriptions(originalTenant.id, languageStrings);

				setSubscriptionCount(subscriptionsRes?.filter(x => {
					const status: string = (x.status as string)?.toLowerCase();

					if (
						status === SubscriptionStatusEnum.Completed
						|| status === SubscriptionStatusEnum.Suspended
						|| (status === SubscriptionStatusEnum.Canceled && (!x.expiryDateRaw || x.expiryDateRaw < new Date()))
					) {
						return false;
					}

					return true;

				}).length);
			})();
		}
		setIsSaveDisabled(true);
		setTenantSiteLibrariesLoaded(false);
		setTenantSiteLibrariesCount(0);
	}, [isOpen]);

	React.useEffect(() => {
		if (newTenant != null && tenant != null && !(tenant.id == null) && originalItem != null) {
			isDirty();
		}
	}, [newTenant]);

	React.useEffect(() => {
		const isTessEnabled: boolean = tenant?.tessUrl?.length > 0 || tenant?.tessClientId?.length > 0 || tenant?.tessClientSecret?.length > 0 || tenant?.tessClientSecretMasked?.length > 0;
		const newTenant: ITenant = {
			...tenant,
			showAllAdvancedSearchFields: checkIfAllFields(tenant, TenantListSections.AdvancedSearch),
			showAllMetaDataFields: checkIfAllFields(tenant, TenantListSections.MetaData),
			showAllSites: checkIfAllFields(tenant, TenantListSections.Sites),
			showAllTeams: checkIfAllFields(tenant, TenantListSections.Teams),
			tessIsEnabled: isTessEnabled,
			clientListIsEnabled: tenant?.clientListUrl?.trim()?.length > 0,
			landingPage: !isTessEnabled && tenant.landingPage === LandingPage.Tess
				? LandingPage.Default
				: tenant.landingPage
		};
		setNewTenant(newTenant);
	}, [tenant]);

	React.useEffect(() => {
		(async () => {
			if (tenant) {
				if (!tenant.sites) {
					getTenantSites(tenant.id);
				} else {
					if (tenant && tenant.sites && tenant.sites.length > 0) {
						if (!tenantSiteLibrariesLoaded) {
							await Promise.all(tenant.sites.map(async (site) => {
								getSiteLibraries(site.id, site.tenantId);
							}));

							setTenantSiteLibrariesLoaded(true);
						} else {
							let count: number = 0;

							tenant.sites.forEach((site) => {
								if (site.documentLibraries && site.documentLibraries.length > 0) {
									count += site.documentLibraries.length;
								}
							});

							setTenantSiteLibrariesCount(count);
						}
					}
				}
			}
		})();
	}, [tenant?.sites, tenantSiteLibrariesLoaded]);

	React.useEffect(() => {
		setNewTenantAdmins(tenantUsers.filter((u) => u.isTenantAdmin));
	}, [tenantUsers]);

	React.useEffect(() => {
		(async () => {
			switch (returnType) {
				case PanelReturnType.Add:
					try {
						const reduxPartner: ITenantPartner = {
							id: newPartner[0].id,
							name: newPartner[0].name
						}

						await assignTenantsAPI(newPartner[0].id, [tenant.id]);
						assignTenants([tenant], reduxPartner);
					} catch (error) {

					}

					setReturnType(null);
					break;
				case PanelReturnType.Remove:
					try {
						await removeTenantsAPI(newPartner[0].id, [tenant.id]);
						removeTenants([tenant], newPartner[0]);
					} catch (error) {

					}

					setReturnType(null);
					break;
				case PanelReturnType.CreateTenant:
					setNewTenant({
						...newTenant,
						partner: newPartner[0],
					});
					setReturnType(null);
					break;
				case PanelReturnType.AssignAdmin:
					const updateStatusAssign: IAdminStatusUpdate = {
						isAdmin: true,
						UserIds: newTenantAdmins.map((u) => u.id),
					};
					updateAdminStatus(updateStatusAssign);
					setReturnType(null);
					break;
				case PanelReturnType.RemoveAdmin:
					const updateStatusRemove: IAdminStatusUpdate = {
						isAdmin: false,
						UserIds: newTenantAdmins.map((u) => u.id),
					};
					updateAdminStatus(updateStatusRemove);
					setReturnType(null);
					break;
			}
		})()
	}, [returnType]);

	const landingPageOptions = React.useMemo(() => {
		const landingPageDropdownOptions = [
			{ key: LandingPage.Default, text: languageStrings.Default },
			{ key: LandingPage.SharePoint, text: "SharePoint" },
			{ key: LandingPage.Teams, text: "Teams" },
			{ key: LandingPage.OneDrive, text: "OneDrive" },
			{ key: LandingPage.Exchange, text: "Exchange" }
		];

		if (newTenant?.tessIsEnabled) {
			landingPageDropdownOptions.push({ key: LandingPage.Tess, text: "Tess" });
		}

		return landingPageDropdownOptions;
	}, [newTenant?.tessIsEnabled]);

	const defaultChannelTabLocationOptions = [
		{ key: DefaultChannelTabLocation.Channel, text: languageStrings.DefaultChannelTabLocationChannel },
		{ key: DefaultChannelTabLocation.Site, text: languageStrings.DefaultChannelTabLocationSite }
	];

	const sortedTenantContextUsage = React.useMemo(() => {
		if (!tenantContextUsage?.length) {
			return [];
		}

		return [...tenantContextUsage].sort((a, b) => {
			const countComparison = b.userCount - a.userCount;

			if (countComparison !== 0) {
				return countComparison;
			}

			return a.context.localeCompare(b.context);
		});
	}, [tenantContextUsage]);

	const maxTenantContextUsageCount = sortedTenantContextUsage.reduce((maxCount, usage) => Math.max(maxCount, usage.userCount), 0);
	const isInitialTenantContextUsageLoading = isTenantContextUsageLoading && tenantContextUsage === null;
	const isTenantContextUsageRefreshing = isTenantContextUsageLoading && tenantContextUsage !== null;

	const loadTenantContextUsage = async (tenantId: number, refresh: boolean = false) => {
		if (!isGlobalAdmin || !tenantId || tenantId <= 0) {
			setTenantContextUsage([]);
			setIsTenantContextUsageLoading(false);
			return;
		}

		const cacheKey = getTenantContextUsageCacheKey(tenantId);

		if (!refresh) {
			const cachedUsage = StorageHelper.getItem(cacheKey);

			if (cachedUsage) {
				try {
					const parsedUsage = JSON.parse(cachedUsage) as ITenantContextUsage[];

					if (Array.isArray(parsedUsage)) {
						setTenantContextUsage(parsedUsage);
						return;
					}
				} catch (error) {
					await StorageHelper.removeItem(cacheKey);
				}
			}
		}

		if (!refresh) {
			setTenantContextUsage(null);
		}

		setIsTenantContextUsageLoading(true);

		try {
			const usage = await getTenantContextUsage(tenantId);

			if (Array.isArray(usage)) {
				setTenantContextUsage(usage);
				await StorageHelper.setItemAsync(cacheKey, JSON.stringify(usage));
			} else if (!refresh) {
				setTenantContextUsage([]);
			}
		} catch (error) {
			ErrorHelper.handle(error);
			if (!refresh) {
				setTenantContextUsage([]);
			}
		} finally {
			setIsTenantContextUsageLoading(false);
		}
	};

	const checkIfAllFields = (tenant: ITenant, type: TenantListSections): boolean => {
		let returnVal: boolean = false;
		let list: string[];
		switch (type) {
			case TenantListSections.AdvancedSearch:
				list = tenant.allowedAdvancedSearchFields as string[];
				//if list does not exist, or the length is zero, or if the only element in there is an empty string
				break;
			case TenantListSections.MetaData:
				list = tenant.hiddenMetadataFields as string[];
				break;
			case TenantListSections.Sites:
				list = tenant.allowedSiteCollections as string[];
				break;
			case TenantListSections.Teams:
				list = tenant.allowedTeams as string[];
				break;
		}
		if (!list || list.length === 0 || (list.length === 1 && list[0] === '')) {
			returnVal = true;
		}

		return returnVal;
	};

	const addCallbackPartner = () => {
		if (tenant.id == 0) {
			setReturnType(PanelReturnType.CreateTenant);
		} else {
			setReturnType(PanelReturnType.Add);
		}
	};

	const removeCallbackPartner = () => {
		setReturnType(PanelReturnType.Remove);
	};

	const addCallbackAdmin = () => {
		setReturnType(PanelReturnType.AssignAdmin);
	};

	const removeCallbackAdmin = () => {
		setReturnType(PanelReturnType.RemoveAdmin);
	};

	const getBase64 = (file: any): Promise<string> => {
		return new Promise((resolve) => {
			let baseURL = "";
			let reader = new FileReader();

			reader.readAsDataURL(file);

			reader.onload = () => {
				baseURL = reader.result as string;
				resolve(baseURL);
			};
		});
	};

	const fileUploaded = async (e: any) => {
		let file = e.target.files[0];
		const res = await getBase64(file);
		const baseParts = res.split(",");

		if (baseParts?.length >= 2) {
			setNewTenant({ ...newTenant, appLogo: res })
		}
	};

	// Accountancy integration accepts only valid absolute https urls. An empty value is allowed
	// (it clears/disables the integration on save); a non-empty value must parse to an https url.
	const isValidHttpsUrl = (value?: string): boolean => {
		const trimmed = value?.trim();
		if (!trimmed) return true;
		try {
			return new URL(trimmed).protocol === 'https:';
		} catch {
			return false;
		}
	};

	// When the Accountancy toggle is on, a non-empty url must be valid before the tenant can be saved.
	const isClientListUrlValid = (): boolean =>
		!newTenant?.clientListIsEnabled || isValidHttpsUrl(newTenant?.clientListUrl);

	const isDirty = () => {
		let enableSave: boolean = false;
		const tenantKeys = Object.keys(newTenant);
		tenantKeys.every((key) => {
			if (key === 'key') return true; //skip key check, bc we get a new key on rerender
			if (typeof newTenant[key] != 'object') {
				//if it is not an array or object, do this code
				if (newTenant[key] != originalItem[key]) {
					if (key === 'showAllAdvancedSearchFields' && newTenant.showAllAdvancedSearchFields === false && newTenant.allowedAdvancedSearchFields?.length === 0) {
						return true;
					}
					if (key === 'showAllSites' && newTenant.showAllSites === false && newTenant.allowedSiteCollections?.length === 0) {
						return true;
					}
					if (key === 'showAllMetaDataFields' && newTenant.showAllMetaDataFields === false && newTenant.hiddenMetadataFields?.length === 0) {
						return true;
					}
					if (key === 'showAllTeams' && newTenant.showAllTeams === false && newTenant.allowedTeams?.length === 0) {
						return true;
					}
					enableSave = true;
					return false;
				}
				return true;
			} else if (!Array.isArray(newTenant[key])) {
				//if it is an object, do this
				if (newTenant.partner?.id != originalItem.partner?.id) {
					enableSave = true;
					return false;
				}
				return true;
			} else {
				//else we are working with an array
				let originalFields: string[] | string;
				let newFields: string[] | string;
				switch (key) {
					case 'allowedAdvancedSearchFields':
						originalFields = originalItem.allowedAdvancedSearchFields;
						newFields = newTenant.allowedAdvancedSearchFields;
						break;
					case 'allowedTeams':
						originalFields = originalItem.allowedTeams;
						newFields = newTenant.allowedTeams;
						break;
					case 'allowedSiteCollections':
						originalFields = originalItem.allowedSiteCollections;
						newFields = newTenant.allowedSiteCollections;
						break;
					case 'hiddenMetadataFields':
						originalFields = originalItem.hiddenMetadataFields;
						newFields = newTenant.hiddenMetadataFields;
						break;
					default:
						originalFields = [];
						newFields = [];
						break;
				}
				if (newFields?.length != originalFields?.length) {
					enableSave = true;
					return false;
				} else {
					if (newFields && originalFields) {
						for (let i = 0; i < newFields.length; i++) {
							if (newFields[i] != originalFields[i]) {
								enableSave = true;
								return false;
							}
						}
					}
				}
				return true;
			}
		});

		setIsSaveDisabled(!enableSave || !isClientListUrlValid());
	};

	const admins = [...tenantUsers].filter((tenantUser) => tenantUser.isTenantAdmin);
	const adminPersonas = admins.map((user, i) => {
		return (
			<Persona
				text={user.displayName}
				secondaryText={user.username}
				size={PersonaSize.size40}
				styles={{
					root: {
						marginTop: 10,
					},
				}}
				key={i}
			/>
		);
	});
	const columns: IColumn[] = [
		{
			key: 'displayName',
			name: languageStrings.DisplayName,
			fieldName: 'displayName',
			data: 'string',
			minWidth: 100,
			maxWidth: 350,
			isResizable: true,
		},
	];
	const renderItemColumn = (item: ITenantUser, index: number, column: IColumn) => {
		const fieldContent = item[column.fieldName as keyof ITenantUser] as string;
		switch (column.key) {
			case 'displayName':
				return <Persona text={item.displayName} size={PersonaSize.size40} secondaryText={item.username} />;
			default:
				return <span>{fieldContent}</span>;
		}
	};

	const renderPartnerItemColumn = (item: IPortalPartner, index: number, column: IColumn) => {
		return <Persona text={item.name} size={PersonaSize.size40} />;
	};

	const getFieldNumber = (type: TenantListSections): string => {
		let fieldLength: number;
		let fieldsText: string = '';
		switch (type) {
			case TenantListSections.AdvancedSearch:
				fieldLength = newTenant.allowedAdvancedSearchFields?.length;
				break;
			case TenantListSections.Sites:
				fieldLength = newTenant.allowedSiteCollections?.length;
				break;
			case TenantListSections.Teams:
				fieldLength = newTenant.allowedTeams?.length;
				break;
			case TenantListSections.MetaData:
				fieldLength = newTenant.hiddenMetadataFields?.length;
				let metaDataFieldText = languageStrings.FieldsHidden.replace('{number}', (fieldLength ?? 0).toString());
				if (fieldLength != 1) {
					metaDataFieldText = languageStrings.FieldHidden.replace('{number}', (fieldLength ?? 0).toString()).replace('{fieldOrSite}', languageStrings.Fields);
				} else {
					metaDataFieldText = metaDataFieldText.replace('{fieldOrSite}', languageStrings.Field);
				}
				return metaDataFieldText;
		}
		fieldsText =
			fieldLength != 1
				? languageStrings.FieldsShown.replace('{number}', (fieldLength ?? 0).toString())
				: languageStrings.FieldShown.replace('{number}', fieldLength.toString());
		if (fieldLength != 1) {
			if (type === TenantListSections.Sites) {
				fieldsText = fieldsText.replace('{fieldOrSite}', languageStrings.Sites);
			} else {
				fieldsText = fieldsText.replace('{fieldOrSite}', languageStrings.Fields);
			}
		} else {
			if (type === TenantListSections.Sites) {
				fieldsText = fieldsText.replace('{fieldOrSite}', languageStrings.Site);
			} else {
				fieldsText = fieldsText.replace('{fieldOrSite}', languageStrings.Field);
			}
		}
		return fieldsText;
	};

	const openListPanel = (type: TenantListSections) => {
		let newTenantListPanels = [...tenantListPanels];
		const index = newTenantListPanels.findIndex((panel) => panel.type === type);
		if (index >= 0) {
			newTenantListPanels[index] = { ...newTenantListPanels[index], isOpen: true };
			setTenantListPanels(newTenantListPanels);
		}
	};
	const closeListPanel = (type: TenantListSections) => {
		let newTenantListPanels = [...tenantListPanels];
		const index = newTenantListPanels.findIndex((panel) => panel.type === type);
		if (index >= 0) {
			newTenantListPanels[index] = { ...newTenantListPanels[index], isOpen: false };
			setTenantListPanels(newTenantListPanels);
		}
	};

	const openAdminConsentWindow = React.useCallback((scopeType: ScopeType) => {
		try {
			const windowName = 'SignInWindow';
			const windowFeatures = 'width=600,height=600,location=no,menubar=no,toolbar=no';
			const windowOrigin = window.location.origin.trimEnd();

			let authUrl: URL = new URL(`${windowOrigin.endsWith("/") ? windowOrigin.slice(0, -1) : windowOrigin}/consent`);
			authUrl.searchParams.append("tid", tenant?.tenantId);
			authUrl.searchParams.append("sct", scopeType.toString());

			window.open(authUrl, windowName, windowFeatures);

		} catch (error) {
			ErrorHelper.handle(error);
		}
	}, [tenant]);

	return (
		newTenant && <Panel
			headerText={`${languageStrings.Edit} ${languageStrings.Tenant}`}
			isOpen={isOpen}
			isLightDismiss
			onDismiss={() => {
				setNewTenant(null);
				setIsSaveDisabled(true);
				setIsOpen(false);
			}}
			closeButtonAriaLabel="Close"
			type={PanelType.custom}
			customWidth={'500px'}
			styles={panelStyle}
		>
			<div className={scrollStyle} style={{ marginBottom: 10 }}>
				<ScrollablePane scrollbarVisibility={ScrollbarVisibility.auto}>
					<Stack tokens={{ childrenGap: 20 }} style={{ paddingRight: 25 }}>
						{errorMessage && <Stack.Item>
							<MessageBar messageBarType={MessageBarType.error}>{errorMessage}</MessageBar>
						</Stack.Item>}
						<Stack.Item style={{ marginTop: 15, marginBottom: 5 }}>
							<Label styles={labelHeadingStyle}>{languageStrings.FriendlyName}</Label>
							<TextField value={newTenant.friendlyName} onChange={(_, nv) => setNewTenant({ ...newTenant, friendlyName: nv })} onGetErrorMessage={validateName} onBlur={isDirty} styles={{ root: { marginTop: 5 } }} />
						</Stack.Item>
						{isGlobalAdmin && <Stack.Item>
							<Stack horizontal horizontalAlign="space-between">
								<Label styles={labelHeadingStyle}>{languageStrings.AppLogo}</Label>
								{isGlobalAdmin && newTenant.id !== 0 && (
									<CommandBarButton
										iconProps={{
											iconName: 'Edit',
											styles: {
												root: {
													color: 'var(--db-fg)',
												},
											},
										}}
										text={languageStrings.Change}
										styles={{
											root: {
												backgroundColor: 'transparent',
											},
										}}
										onClick={() => {
											fileUploadInput.current.click();
										}}
									/>
								)}
							</Stack>
							<div>
								<input className="hidden" ref={fileUploadInput} id="cameraFileInput" type="file" accept="image/*" capture="environment" onChange={(e) => fileUploaded(e)} />
								<div style={{ padding: 15, backgroundColor: newTenant.appColor ?? "#0001FF" }}><Image src={newTenant.appLogo || DOCUBIRD_LOGO} width={200} height={"auto"} /></div>
								{newTenant.appLogo && <Link onClick={() => setNewTenant({ ...newTenant, appLogo: undefined })}>Remove</Link>}
							</div>
						</Stack.Item>}
						{isGlobalAdmin && <Stack.Item>
							<Stack horizontal horizontalAlign="space-between">
								<Label styles={labelHeadingStyle}>{languageStrings.AppColor}</Label>
								{isGlobalAdmin && newTenant.id !== 0 && (
									<CommandBarButton
										iconProps={{
											iconName: 'Edit',
											styles: {
												root: {
													color: 'var(--db-fg)',
												},
											},
										}}
										text={languageStrings.Change}
										styles={{
											root: {
												backgroundColor: 'transparent',
											},
										}}
										onClick={() => {
											setIsColorPickerPanelOpen(true);
										}}
									/>
								)}
							</Stack>
							{!newTenant.appColor && <Label styles={labelInfoStyle} disabled>No color selected</Label>}
							{newTenant.appColor &&
								<div style={{ backgroundColor: newTenant.appColor, width: 50, height: 50 }}></div>
							}
							{newTenant.appColor && <Link onClick={() => setNewTenant({ ...newTenant, appColor: undefined })}>Remove</Link>}
						</Stack.Item>}
						{isGlobalAdmin && <Stack.Item>
							<Label styles={labelHeadingStyle}>{languageStrings.AppTitle}</Label>
							<TextField value={newTenant.appTitle} onChange={(_, nv) => setNewTenant({ ...newTenant, appTitle: nv })} styles={{ root: { marginTop: 5 } }} />
						</Stack.Item>}
						<Stack.Item>
							<Label styles={labelHeadingStyle}>{languageStrings.DateRegistered}</Label>
							<Label styles={labelInfoStyle} disabled>{`${new Date().toLocaleDateString()}`}</Label>
						</Stack.Item>
						<Stack.Item>
							<Label styles={labelHeadingStyle}>{languageStrings.TenantId}</Label>
							<Label styles={labelInfoStyle} disabled>
								{tenant?.tenantId}
							</Label>
						</Stack.Item>
						<Stack.Item>
							<Label styles={labelHeadingStyle}>{languageStrings.NumberOfUsers}</Label>
							<Label styles={labelInfoStyle} disabled>
								{tenantUsers?.length}
							</Label>
						</Stack.Item>
						<Stack.Item>
							<Label styles={labelHeadingStyle}>{languageStrings.Subscriptions}</Label>
							<Link href="#" onClick={(ev) => {
								ev.preventDefault();
								setIsOpen(false);
								navigate('/subscriptions/' + tenant.id);
							}}>{`${subscriptionCount} ${languageStrings.ActiveSubscriptions.toLocaleLowerCase()}`}</Link>
						</Stack.Item>
						{isGlobalAdmin && (
							<Stack.Item>
								<Stack horizontal horizontalAlign="space-between">
									<Label styles={labelHeadingStyle}>{languageStrings.UserContextUsage}</Label>
									<CommandBarButton
										iconProps={{
											iconName: "Refresh",
											styles: {
												root: {
													color: 'var(--db-fg)',
												},
											},
										}}
										text={languageStrings.Refresh}
										disabled={isTenantContextUsageLoading || !tenant?.id || tenant.id <= 0}
										onRenderIcon={isTenantContextUsageRefreshing
											? () => <Spinner size={SpinnerSize.small} style={{ marginLeft: 4, marginRight: 4 }} />
											: undefined}
										styles={{
											root: {
												backgroundColor: 'transparent',
											},
										}}
										onClick={() => loadTenantContextUsage(tenant.id, true)}
									/>
								</Stack>
								{isInitialTenantContextUsageLoading ? (
									<Spinner size={SpinnerSize.small} />
								) : sortedTenantContextUsage.length > 0 ? (
									<div className={contextUsageListStyle}>
										{sortedTenantContextUsage.map((usage) => {
											const barWidth = maxTenantContextUsageCount > 0 && usage.userCount > 0
												? `${Math.max((usage.userCount / maxTenantContextUsageCount) * 100, 8)}%`
												: '0%';

											return (
												<div key={usage.context} className={contextUsageRowStyle}>
													<div className={contextUsageRowHeaderStyle}>
														<span className={contextUsageNameStyle} title={usage.context}>{usage.context}</span>
														<span className={contextUsageCountStyle}>{usage.userCount}</span>
													</div>
													<div className={contextUsageBarTrackStyle} aria-hidden="true">
														<div className={contextUsageBarFillStyle} style={{ width: barWidth }} />
													</div>
												</div>
											);
										})}
									</div>
								) : (
									<div className={contextUsageEmptyStateStyle}>{languageStrings.NoActivityFound}</div>
								)}
							</Stack.Item>
						)}
						<Stack.Item>
							<Stack>
								<Label styles={labelHeadingStyle}>{languageStrings.AdminConsent}</Label>
								<div style={{ paddingTop: 5, paddingBottom: 15 }}>
									<DefaultButton styles={consentButtonStyles}
										onClick={() => openAdminConsentWindow(ScopeType.Graph)}
									>
										{languageStrings.ConsentToUserPermissions}
									</DefaultButton>
								</div>
								<div style={{ paddingTop: 5, paddingBottom: 15 }}>
									<DefaultButton styles={consentButtonStyles}
										onClick={() => openAdminConsentWindow(ScopeType.SharePoint)}
									>
										{languageStrings.ConsentToSharePointPermissions}
									</DefaultButton>
								</div>
								<div style={{ paddingTop: 5, paddingBottom: 15 }}>
									<DefaultButton styles={consentButtonStyles}
										onClick={() => openAdminConsentWindow(ScopeType.Approvals)}
									>
										{languageStrings.ConsentToApprovalPermissions}
									</DefaultButton>
								</div>
							</Stack>
						</Stack.Item>
						<Stack.Item style={{ marginBottom: 5 }}>
							<ApiKeyItem tenant={newTenant} updateTenant={updateTenant} />
						</Stack.Item>
						{(isTenantAdmin || isGlobalAdmin) && (
							<Stack>
								<Stack horizontal horizontalAlign="space-between">
									<Label styles={labelHeadingStyle}>{languageStrings.Partner}</Label>
									{isGlobalAdmin && newTenant.id !== 0 && (
										<CommandBarButton
											iconProps={{
												iconName: 'Edit',
												styles: {
													root: {
														color: 'var(--db-fg)',
													},
												},
											}}
											text={languageStrings.Manage}
											styles={{
												root: {
													backgroundColor: 'transparent',
												},
											}}
											onClick={() => {
												setIsPartnerViewListOpen(true);
											}}
										/>
									)}
								</Stack>
								{newTenant.partner ? (
									<Persona
										text={newTenant.partner?.name}
										//secondaryText={newTenant.partner?.username}
										size={PersonaSize.size40}
										styles={{
											root: {
												marginTop: 10,
											},
										}}
									/>
								) : (
									<Label styles={labelInfoStyle} disabled>
										{!newTenant.partner ? languageStrings.NoPartner : null}
									</Label>
								)}
							</Stack>
						)}
						<Stack.Item style={{ marginBottom: 5 }}>
							<Stack horizontal horizontalAlign="space-between">
								<Label styles={labelHeadingStyle}>{languageStrings.AdminUsers}</Label>
								{tenantUsers?.length > 0 && (
									<CommandBarButton
										iconProps={{
											iconName: 'Edit',
											styles: {
												root: {
													color: 'var(--db-fg)',
												},
											},
										}}
										text={languageStrings.Manage}
										styles={{
											root: {
												backgroundColor: 'transparent',
											},
										}}
										onClick={() => {
											setIsAdminViewListOpen(true);
										}}
									/>
								)}
							</Stack>
							{adminPersonas.length > 0 ? (
								adminPersonas.length > 3 ? (
									<>
										{adminPersonas.slice(0, 3)}
										<Label
											onClick={() => {
												setIsAdminViewListOpen(true);
											}}
											styles={{
												root: {
													cursor: 'pointer',
													width: 100,
													marginTop: 10,
													selectors: {
														':hover': {
															color: 'var(--db-accent)',
															backgroundColor: 'var(--db-hover-bg)',
														},
													},
												},
											}}
										>
											... and {adminPersonas.length - 3} others
										</Label>
									</>
								) : (
									adminPersonas
								)
							) : (
								<Label styles={labelInfoStyle} disabled>
									{languageStrings.NoTenantAdmins}
								</Label>
							)}
						</Stack.Item>
						<Stack.Item style={sectionSeparator}>
							<Label styles={labelHeadingStyle}>{languageStrings.GeneralSettings}</Label>
							<Toggle label={languageStrings.Show + ' SharePoint'} checked={newTenant.enableSharePoint} onChange={() => setNewTenant({ ...newTenant, enableSharePoint: !newTenant.enableSharePoint })} onText={languageStrings.Yes} offText={languageStrings.No} />
							<Toggle label={languageStrings.Show + ' Teams'} checked={newTenant.enableTeams} onChange={() => setNewTenant({ ...newTenant, enableTeams: !newTenant.enableTeams })} onText={languageStrings.Yes} offText={languageStrings.No} />
							<Toggle label={languageStrings.Show + ' OneDrive'} checked={newTenant.enableOneDrive} onChange={() => setNewTenant({ ...newTenant, enableOneDrive: !newTenant.enableOneDrive })} onText={languageStrings.Yes} offText={languageStrings.No} />
							<Toggle label={languageStrings.EnableApprovals} checked={newTenant.enableApprovals} onChange={() => setNewTenant({ ...newTenant, enableApprovals: !newTenant.enableApprovals })} onText={languageStrings.Yes} offText={languageStrings.No} />
							<Toggle
								label={languageStrings.AllowOpenInSharePoint}
								checked={newTenant.allowOpenInSharePoint ?? true}
								onChange={(_event: React.MouseEvent<HTMLElement, MouseEvent>, checked?: boolean) => setNewTenant({ ...newTenant, allowOpenInSharePoint: checked ?? false })}
								onText={languageStrings.Yes}
								offText={languageStrings.No}
							/>
							<Toggle
								label={languageStrings.HideAutoPreview}
								checked={newTenant.hideAutoPreview ?? false}
								onChange={(_event: React.MouseEvent<HTMLElement, MouseEvent>, checked?: boolean) => setNewTenant({ ...newTenant, hideAutoPreview: checked ?? false })}
								onText={languageStrings.Yes}
								offText={languageStrings.No}
							/>
							<Stack.Item>
								<Label styles={labelHeadingStyle}>{languageStrings.LandingPage}</Label>
								<Dropdown
									style={{ marginTop: 7 }}
									styles={dropdownStyles}
									selectedKey={newTenant?.landingPage ? newTenant?.landingPage?.valueOf() : landingPageOptions[0].key}
									onChange={(_e, o) => setNewTenant({ ...newTenant, landingPage: Number(o.key) })}
									options={landingPageOptions}
								/>
							</Stack.Item>
						</Stack.Item>
						{isGlobalAdmin && <Stack.Item style={sectionSeparator}>
							<Label styles={labelHeadingStyle}>Global Admin Only</Label>
							<Toggle
								label="Enable Global Advanced Search"
								checked={newTenant.enableAdvSearchMultiSites ? true : false}
								onChange={(_event: React.MouseEvent<HTMLElement, MouseEvent>, checked?: boolean) => setNewTenant(prevTenant => ({ ...prevTenant, enableAdvSearchMultiSites: checked ?? false }))}
								onText={languageStrings.Yes}
								offText={languageStrings.No}
							/>
							<Toggle
								label="Disable Content Types in Advanced Search"
								checked={newTenant.disableAdvSearchContentTypes ? true : false}
								onChange={(_event: React.MouseEvent<HTMLElement, MouseEvent>, checked?: boolean) => setNewTenant(prevTenant => ({ ...prevTenant, disableAdvSearchContentTypes: checked ?? false }))}
								onText={languageStrings.Yes}
								offText={languageStrings.No}
							/>
							<Toggle
								label="Enforce strict Document Sets only"
								checked={newTenant.enforceStrictDocumentSetsOnly ? true : false}
								onChange={(_event: React.MouseEvent<HTMLElement, MouseEvent>, checked?: boolean) => setNewTenant(prevTenant => ({ ...prevTenant, enforceStrictDocumentSetsOnly: checked ?? false }))}
								onText={languageStrings.Yes}
								offText={languageStrings.No}
							/>
							<Toggle
								label={"Enable provisioned sites registration"}
								checked={newTenant.enableProvisionedSiteRegistration ? true : false}
								onChange={(_event: React.MouseEvent<HTMLElement, MouseEvent>, checked?: boolean) => setNewTenant(prevTenant => ({ ...prevTenant, enableProvisionedSiteRegistration: checked ?? false }))}
								onText={languageStrings.Yes}
								offText={languageStrings.No}
							/>
						</Stack.Item>}
						<Stack.Item style={sectionSeparator}>
							<Label styles={labelHeadingStyle}>{languageStrings.OutlookSettings}</Label>
							<Toggle disabled={true} label={languageStrings.SaveOnSend} checked={newTenant.saveOnSend ? true : false} onChange={() => setNewTenant({ ...newTenant, saveOnSend: !newTenant.saveOnSend })} onText={languageStrings.Yes} offText={languageStrings.No} />
							<Toggle
								label={languageStrings.AutoSelectAttachments}
								checked={newTenant.autoSelectAttachments ? true : false}
								onChange={() => setNewTenant({ ...newTenant, autoSelectAttachments: !newTenant.autoSelectAttachments })}
								onText={languageStrings.Yes}
								offText={languageStrings.No}
							/>
							<Toggle
								label={languageStrings.AutoRemoveMailItemAttachments}
								checked={newTenant.autoRemoveMailItemAttachments ? true : false}
								onChange={() => setNewTenant({ ...newTenant, autoRemoveMailItemAttachments: !newTenant.autoRemoveMailItemAttachments })}
								onText={languageStrings.Yes}
								offText={languageStrings.No}
							/>
							<Toggle
								label={languageStrings.ConvertEmailToPdf}
								checked={newTenant.convertEmailToPDF ? true : false}
								onChange={() => setNewTenant({ ...newTenant, convertEmailToPDF: !newTenant.convertEmailToPDF })}
								onText={languageStrings.Yes}
								offText={languageStrings.No}
							/>
							<Toggle
								label={languageStrings.DisableMailCategorization}
								checked={newTenant.disableMailCategorization ? true : false}
								onChange={(_event: React.MouseEvent<HTMLElement, MouseEvent>, checked?: boolean) => setNewTenant({ ...newTenant, disableMailCategorization: checked ?? false })}
								onText={languageStrings.Yes}
								offText={languageStrings.No}
							/>
						</Stack.Item>
						<Stack.Item style={sectionSeparator}>
							<Label styles={labelHeadingStyle}>{languageStrings.ExchangeSettings}</Label>
							<Toggle label={languageStrings.Enable} checked={newTenant.enableExchange ? true : false} onChange={() => setNewTenant({ ...newTenant, enableExchange: !newTenant.enableExchange })} onText={languageStrings.Yes} offText={languageStrings.No} />
							<Label
								styles={{
									root: {
										fontWeight: FontWeights.regular,
									},
								}}
							>
								{languageStrings.EmailHeaderMapping}
							</Label>
							<DefaultButton
								onClick={() => {
									setIsEmailMappingPanelOpen(true);
								}}
								style={{ marginTop: 10 }}
							>
								{languageStrings.Manage}
							</DefaultButton>
						</Stack.Item>
						<ListToggleSection
							heading={languageStrings.TeamSettings}
							toggleLabel={languageStrings.ShowAllTeams}
							numberOfFields={getFieldNumber(TenantListSections.Teams)}
							toggleSetterCallback={() => setNewTenant({ ...newTenant, showAllTeams: !newTenant.showAllTeams })}
							toggleValue={newTenant.showAllTeams ?? true}
							hasEditButton
							editButtonCallback={() => {
								openListPanel(TenantListSections.Teams);
							}}
							editButtonText={languageStrings.Manage}
							mainStyle={sectionSeparator}
						/>
						<Stack.Item style={{ marginTop: 0 }}>
							<Toggle
								label={languageStrings.HideTeamsSitesInSharePoint}
								checked={newTenant.hideTeamsSitesInSharePoint ? true : false}
								onChange={(_event: React.MouseEvent<HTMLElement, MouseEvent>, checked?: boolean) => setNewTenant({ ...newTenant, hideTeamsSitesInSharePoint: checked ?? false })}
								onText={languageStrings.Yes}
								offText={languageStrings.No}
							/>
							<Toggle
								label={languageStrings.HideDocumentLibrariesInTeams}
								checked={newTenant.hideDocumentLibrariesInTeams ? true : false}
								onChange={(_event: React.MouseEvent<HTMLElement, MouseEvent>, checked?: boolean) => setNewTenant({ ...newTenant, hideDocumentLibrariesInTeams: checked ?? false })}
								onText={languageStrings.Yes}
								offText={languageStrings.No}
							/>
							<Stack.Item>
								<Label styles={labelHeadingStyle}>{languageStrings.DefaultChannelTabLocation}</Label>
								<Dropdown
									style={{ marginTop: 7 }}
									styles={dropdownStyles}
									selectedKey={newTenant?.defaultChannelTabLocation ? newTenant?.defaultChannelTabLocation?.valueOf() : defaultChannelTabLocationOptions[0].key}
									onChange={(_e, o) => setNewTenant({ ...newTenant, defaultChannelTabLocation: Number(o.key) === DefaultChannelTabLocation.Channel ? undefined : Number(o.key) })}
									options={defaultChannelTabLocationOptions}
								/>
							</Stack.Item>
						</Stack.Item>
						<ListToggleSection
							heading={languageStrings.MetaDataSettings}
							toggleLabel={languageStrings.ShowAllMetadata}
							numberOfFields={getFieldNumber(TenantListSections.MetaData)}
							toggleSetterCallback={() => setNewTenant({ ...newTenant, showAllMetaDataFields: !newTenant.showAllMetaDataFields })}
							toggleValue={newTenant.showAllMetaDataFields ?? true}
							hasEditButton
							editButtonCallback={() => {
								openListPanel(TenantListSections.MetaData);
							}}
							editButtonText={languageStrings.Manage}
							mainStyle={sectionSeparator}
						/>
						<ListToggleSection
							heading={languageStrings.AdvancedSearchSettings}
							toggleLabel={languageStrings.ShowAllFields}
							numberOfFields={getFieldNumber(TenantListSections.AdvancedSearch)}
							toggleSetterCallback={() => setNewTenant({ ...newTenant, showAllAdvancedSearchFields: !newTenant.showAllAdvancedSearchFields })}
							toggleValue={newTenant.showAllAdvancedSearchFields ?? true}
							hasEditButton
							editButtonCallback={() => {
								openListPanel(TenantListSections.AdvancedSearch);
							}}
							editButtonText={languageStrings.Manage}
							mainStyle={sectionSeparator}
						/>
						<Stack.Item style={sectionSeparator}>
							<Label styles={labelHeadingStyle}>{languageStrings.DocumentSettings}</Label>
							<Toggle
								label={languageStrings.DisableDocumentRename}
								checked={newTenant.disableFileRename ? true : false}
								onChange={(_event: React.MouseEvent<HTMLElement, MouseEvent>, checked?: boolean) => setNewTenant({ ...newTenant, disableFileRename: checked ?? false })}
								onText={languageStrings.Yes}
								offText={languageStrings.No}
							/>
							<Toggle
								label={languageStrings.OpenDocumentsInClientApp}
								checked={newTenant.openDocumentsInClientApp ? true : false}
								onChange={(_event: React.MouseEvent<HTMLElement, MouseEvent>, checked?: boolean) => setNewTenant({ ...newTenant, openDocumentsInClientApp: checked ?? false })}
								onText={languageStrings.Yes}
								offText={languageStrings.No}
							/>
							<Toggle
								label={languageStrings.EnableCopyMoveTo}
								checked={newTenant.enableCopyMoveTo ? true : false}
								onChange={(_event: React.MouseEvent<HTMLElement, MouseEvent>, checked?: boolean) => setNewTenant({ ...newTenant, enableCopyMoveTo: checked ?? false })}
								onText={languageStrings.Yes}
								offText={languageStrings.No}
							/>
							<Toggle
								label={languageStrings.EnableSharing}
								checked={newTenant.enableSharing ? true : false}
								onChange={(_event: React.MouseEvent<HTMLElement, MouseEvent>, checked?: boolean) => setNewTenant({ ...newTenant, enableSharing: checked ?? false })}
								onText={languageStrings.Yes}
								offText={languageStrings.No}
							/>
							<Toggle
								label={languageStrings.DisableAutoOpenAfterNewFileFromTemplate}
								checked={newTenant.disableAutoOpenAfterNewFileFromTemplate ? true : false}
								onChange={(_event: React.MouseEvent<HTMLElement, MouseEvent>, checked?: boolean) => setNewTenant(prevTenant => ({ ...prevTenant, disableAutoOpenAfterNewFileFromTemplate: checked ?? false }))}
								onText={languageStrings.Yes}
								offText={languageStrings.No}
							/>
						</Stack.Item>
						<Stack.Item style={sectionSeparator}>
							<Label styles={labelHeadingStyle}>{languageStrings.FilterSettings}</Label>
							<Toggle
								label={languageStrings.EnableQuickFilter}
								checked={newTenant.enableQuickFilter ? true : false}
								onChange={(_event: React.MouseEvent<HTMLElement, MouseEvent>, checked?: boolean) => setNewTenant(prevTenant => ({ ...prevTenant, enableQuickFilter: checked ?? false }))}
								onText={languageStrings.Yes}
								offText={languageStrings.No}
							/>
							<Toggle
								label={languageStrings.HideTitleFieldFilter}
								checked={newTenant.hideTitleFieldFilter ? true : false}
								onChange={(_event: React.MouseEvent<HTMLElement, MouseEvent>, checked?: boolean) => setNewTenant(prevTenant => ({ ...prevTenant, hideTitleFieldFilter: checked ?? false }))}
								onText={languageStrings.Yes}
								offText={languageStrings.No}
							/>
							<Toggle
								label={languageStrings.AutoOpenFilterSearchbox}
								checked={newTenant.autoOpenFilterSearchbox ? true : false}
								onChange={(_event: React.MouseEvent<HTMLElement, MouseEvent>, checked?: boolean) => setNewTenant(prevTenant => ({ ...prevTenant, autoOpenFilterSearchbox: checked ?? false }))}
								onText={languageStrings.Yes}
								offText={languageStrings.No}
							/>
						</Stack.Item>
						{/* <Stack.Item style={sectionSeparator}>
							<Label styles={labelHeadingStyle}>{languageStrings.PermissionSettings}</Label>
							<Toggle
								label={languageStrings.EnablePermissionManagent}
								checked={newTenant.enablePermissionManagement ? true : false}
								onChange={(_event: React.MouseEvent<HTMLElement, MouseEvent>, checked?: boolean) => setNewTenant({ ...newTenant, enablePermissionManagement: checked ?? false })}
								onText={languageStrings.Yes}
								offText={languageStrings.No}
							/>
						</Stack.Item> */}
						{/* <Stack.Item style={sectionSeparator}>
							<Label styles={labelHeadingStyle}>{languageStrings.PIISettings}</Label>
							<Toggle
								label={languageStrings.EnablePII}
								checked={newTenant.enablePII ?? true}
								onChange={(_event: React.MouseEvent<HTMLElement, MouseEvent>, checked?: boolean) => setNewTenant({ ...newTenant, enablePII: checked ?? false, enableRedaction: checked ? newTenant.enableRedaction : false })}
								onText={languageStrings.Yes}
								offText={languageStrings.No}
							/>
							{newTenant.enablePII && (
								<Toggle
									label={languageStrings.EnablePIIRedaction}
									checked={newTenant.enableRedaction ?? true}
									onChange={(_event: React.MouseEvent<HTMLElement, MouseEvent>, checked?: boolean) => setNewTenant({ ...newTenant, enableRedaction: checked ?? false })}
									onText={languageStrings.Yes}
									offText={languageStrings.No}
								/>
							)}
							<Label
								styles={{
									root: {
										fontWeight: FontWeights.regular,
									},
								}}
							>
								{`${newTenant.piiInfoTypes ? newTenant.piiInfoTypes.split(';')?.length : 0} ${languageStrings.InfoTypesSelected}`}
							</Label>
							<DefaultButton
								disabled={!newTenant.enablePII}
								onClick={() => {
									setIsSelectPiiInfoTypesPanelOpen(true);
								}}
								style={{ marginTop: 10 }}
							>
								{languageStrings.Manage}
							</DefaultButton>
						</Stack.Item> */}
						<Stack.Item style={sectionSeparator}>
							<Label styles={labelHeadingStyle}>{languageStrings.OcrSettings}</Label>
							<Label styles={labelInfoStyle}>{`${languageStrings.Status}: ${newTenant?.ocrLanguage ? languageStrings.Enabled : languageStrings.Disabled}`}</Label>
							<Dropdown
								label={languageStrings.OcrLanguage}
								disabled={!(isGlobalAdmin || isPartner)}
								styles={{
									root: {
										marginTop: 7,
									},
								}}
								selectedKey={newTenant?.ocrLanguage?.valueOf()}
								onChange={(_e, o) => setNewTenant({ ...newTenant, ocrLanguage: o.key?.toString() })}
								options={ocrLanguageDropDownOptions}
							/>
						</Stack.Item>
						<Stack.Item style={sectionSeparator}>
							<Label styles={labelHeadingStyle}>{languageStrings.NewTemplateSettings}</Label>
							<Toggle
								label={languageStrings.EnableNewTemplateFilters}
								checked={newTenant.enableNewTemplateFilters ?? true}
								onChange={(_event: React.MouseEvent<HTMLElement, MouseEvent>, checked?: boolean) => setNewTenant({ ...newTenant, enableNewTemplateFilters: checked ?? false })}
								onText={languageStrings.Yes}
								offText={languageStrings.No}
							/>
							{newTenant.enableNewTemplateFilters && (
								<>
									<Dropdown
										multiSelect
										label={languageStrings.InsideDocumentLibrary}
										disabled={!(isGlobalAdmin || isPartner)}
										styles={{
											root: {
												marginTop: 7,
											},
										}}
										selectedKeys={newTenant?.newTemplateLibraryFilters ? newTenant?.newTemplateLibraryFilters.split(';') : []}
										onChange={(_e, o) => {
											const options = newTenant?.newTemplateLibraryFilters ? newTenant?.newTemplateLibraryFilters.split(';') : [];
											if (options.includes(o.key as string) && o.selected === false) {
												setNewTenant({ ...newTenant, newTemplateLibraryFilters: options.filter((x) => x !== (o.key as string)).join(';') });
											}
											if (!options.includes(o.key as string) && o.selected === true) {
												options.push(o.key as string);
												setNewTenant({ ...newTenant, newTemplateLibraryFilters: options.join(';') });
											}
										}}
										options={newTemplateTypesDropDownOptions}
									/>
									<Dropdown
										multiSelect
										label={languageStrings.InsideFolder}
										disabled={!(isGlobalAdmin || isPartner)}
										styles={{
											root: {
												marginTop: 7,
											},
										}}
										selectedKeys={newTenant?.newTemplateFolderFilters ? newTenant?.newTemplateFolderFilters.split(';') : []}
										onChange={(_e, o) => {
											const options = newTenant?.newTemplateFolderFilters ? newTenant?.newTemplateFolderFilters.split(';') : [];
											if (options.includes(o.key as string) && o.selected === false) {
												setNewTenant({ ...newTenant, newTemplateFolderFilters: options.filter((x) => x !== (o.key as string)).join(';') });
											}
											if (!options.includes(o.key as string) && o.selected === true) {
												options.push(o.key as string);
												setNewTenant({ ...newTenant, newTemplateFolderFilters: options.join(';') });
											}
										}}
										options={newTemplateTypesDropDownOptions}
									/>
									<Dropdown
										multiSelect
										label={languageStrings.InsideDocumentSet}
										disabled={!(isGlobalAdmin || isPartner)}
										styles={{
											root: {
												marginTop: 7,
											},
										}}
										selectedKeys={newTenant?.newTemplateDocumentSetFilters ? newTenant?.newTemplateDocumentSetFilters.split(';') : []}
										onChange={(_e, o) => {
											const options = newTenant?.newTemplateDocumentSetFilters ? newTenant?.newTemplateDocumentSetFilters.split(';') : [];
											if (options.includes(o.key as string) && o.selected === false) {
												setNewTenant({ ...newTenant, newTemplateDocumentSetFilters: options.filter((x) => x !== (o.key as string)).join(';') });
											}
											if (!options.includes(o.key as string) && o.selected === true) {
												options.push(o.key as string);
												setNewTenant({ ...newTenant, newTemplateDocumentSetFilters: options.join(';') });
											}
										}}
										options={newTemplateTypesDropDownOptions.filter((x) => x.key !== 'docset')}
									/>
								</>
							)}
							{/* Lives here rather than under Integrations: this governs the placeholders
							    offered while AUTHORING a template, which is what this section is about.

							    Two ordinary tenant settings - they ride newTenant, so the generic
							    isDirty() walk arms the Save button and Tenant/Update persists them,
							    exactly like every other control in this panel.

							    Hidden entirely for a tenant with no document template datasource: the
							    add-in command that consumes the flag cannot render without one, so the
							    toggle would be inert. See templateAiSectionState. */}
							{aiSection.showToggle && (
								<Toggle
									label={languageStrings.AiTemplateSuggestions}
									checked={newTenant.templateAiEnabled ?? false}
									disabled={aiSection.toggleDisabled}
									onChange={(_, checked?: boolean) =>
										setNewTenant({ ...newTenant, templateAiEnabled: checked ?? false })}
									onText={languageStrings.Yes}
									offText={languageStrings.No}
								/>
							)}
							{/* Switched on, but the SERVER cannot run the feature (section disabled,
							    or no Endpoint/ApiKey). The toggle above stays LIVE for this case so
							    the flag can be cleared - it is the consent gate for template text
							    leaving the infrastructure, and hiding it would strand it on with no
							    way to see or change it. The reason names the missing key, so an admin
							    does not need server logs. */}
							{aiSection.showFeatureUnavailableWarning && (
								<MessageBar messageBarType={MessageBarType.warning}>
									{languageStrings.AiTemplateSuggestionsUnavailable}
									{templateAiMeta?.featureDisabledReason ? ` (${templateAiMeta.featureDisabledReason})` : ""}
								</MessageBar>
							)}
							{/* Switched on, but the template library it needs is gone. Same escape
							    hatch, for the same reason. */}
							{aiSection.showNoTemplateLibraryWarning && (
								<MessageBar messageBarType={MessageBarType.warning}>
									{languageStrings.AiTemplateSuggestionsNoLibrary}
								</MessageBar>
							)}
							{/* Only when there is a genuine tie to break (>1 CRM datasource TYPE).
							    Governs which client-field labels the AI may propose - it does not
							    change which datasource fills placeholders at creation time.

							    "Infer automatically" is the FIRST option, not a placeholder: NULL is
							    the documented default and a single-select Dropdown offers no way to
							    deselect, so without it a choice once made could never be undone. */}
							{aiSection.showCrmPicker && (
								<Dropdown
									label={languageStrings.AiTemplateSuggestionsClientFields}
									styles={dropdownStyles}
									selectedKey={templateAiSelectedCrmKey(newTenant.templateAiCrmDatasourceId)}
									options={templateAiCrmOptions(templateAiMeta, languageStrings.AiTemplateSuggestionsInfer)}
									onChange={(_, option) => setNewTenant({
										...newTenant,
										templateAiCrmDatasourceId: templateAiCrmKeyToStoredId(option?.key),
									})}
								/>
							)}
							{/* Readiness summary. Shown only while the feature is switched ON, for the
							    same reason as the picker: the section stays quiet for a tenant not
							    using it, and flipping the toggle to look costs nothing now that it is
							    a draft. It states what WORKS as well as what does not - a lone warning
							    reads as "this is broken" when the feature is merely partial, and
							    custom fields need no tenant configuration at all.

							    hasClientListUrl comes from the DRAFT tenant, so typing a URL into the
							    Accountancy section flips the client row before anything is saved.
							    See templateAiCapabilities. */}
							{aiSection.showCapabilities && (
								<div style={{ marginTop: 10 }}>
									<Label styles={labelInfoStyle}>{languageStrings.AiTemplateSuggestionsAvailableFor}</Label>
									{templateAiCapabilities(
										templateAiMeta,
										// Mirrors the SAVE rule exactly (redux updateTenant thunk): a url is
										// only persisted while the Accountancy toggle is on, and is nulled
										// out otherwise. Reading the url alone would promise "✓ Client
										// fields" for a draft whose save is about to clear it.
										newTenant.clientListIsEnabled === true
											&& newTenant.clientListUrl?.trim()?.length > 0,
									).map(capability => {
										// Mapped here rather than in the helper: that module is
										// deliberately localisation-agnostic (see templateAiCrmOptions,
										// which takes its one string as a parameter for the same reason).
										const label = {
											custom: languageStrings.AiTemplateSuggestionsCapabilityCustom,
											builtin: languageStrings.AiTemplateSuggestionsCapabilityBuiltin,
											client: languageStrings.AiTemplateSuggestionsCapabilityClient,
										}[capability.key];
										const reason = capability.missing.map(prerequisite =>
											prerequisite === 'crmDatasource'
												? languageStrings.AiTemplateSuggestionsMissingCrmDatasource
												: languageStrings.AiTemplateSuggestionsMissingClientList).join(', ');

										return (
											<div
												key={capability.key}
												style={{ display: 'flex', alignItems: 'center', gap: 6, marginTop: 4 }}
											>
												<Icon
													iconName={capability.available ? 'CompletedSolid' : 'WarningSolid'}
													styles={{
														root: {
															fontSize: 12,
															// Theme tokens, never literals: the panel renders in
															// both light and dark.
															color: capability.available
																? 'var(--db-success-fg)'
																: 'var(--db-pill-warning-fg)',
														},
													}}
												/>
												<span style={{ fontSize: 12, color: 'var(--db-fg-muted)' }}>
													{reason ? `${label} — ${reason}` : label}
												</span>
											</div>
										);
									})}
								</div>
							)}
						</Stack.Item>
						<Stack.Item style={sectionSeparator}>
							<Label styles={labelHeadingStyle}>{languageStrings.VersionSettings}</Label>
							<TextField
								label={languageStrings.MinimumVersionLimit}
								value={newTenant.minVersionLimit?.toString()}
								type="number"
								onChange={(event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) => {
									let newLimit = +newValue < 0 ? 0 : +newValue;
									setNewTenant({ ...newTenant, minVersionLimit: newLimit });
								}}
							/>
							<Toggle
								label={languageStrings.AutoDeleteMinorVersionsOnPublish}
								checked={newTenant.autoDeleteMinorVersionsOnPublish ?? true}
								onChange={(_event: React.MouseEvent<HTMLElement, MouseEvent>, checked?: boolean) => setNewTenant({ ...newTenant, autoDeleteMinorVersionsOnPublish: checked ?? false })}
								onText={languageStrings.Yes}
								offText={languageStrings.No}
							/>
							<TextField
								label={languageStrings.RequiredMetadataOnPublish}
								value={newTenant.requiredMetadataOnPublish}
								type="text"
								onChange={(event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) => {
									setNewTenant({ ...newTenant, requiredMetadataOnPublish: newValue });
								}}
							/>
						</Stack.Item>
						{/* <Stack>
							<ListToggleSection
								heading={languageStrings.SiteSettings}
								toggleLabel={languageStrings.ShowAllSites}
								numberOfFields={getFieldNumber(TenantListSections.Sites)}
								toggleSetterCallback={() => setNewTenant({ ...newTenant, showAllSites: !newTenant.showAllSites })}
								toggleValue={newTenant.showAllSites ?? true}
								hasEditButton
								editButtonCallback={() => {
									openListPanel(TenantListSections.Sites);
								}}
								editButtonText={languageStrings.Manage}
								mainStyle={sectionSeparator}
							/>
							<Stack horizontalAlign="start" style={{ marginTop: 10 }}>
								<DefaultButton onClick={() => setIsManageSitesOpen(true)}>{languageStrings.AdvancedSiteSettings}</DefaultButton>
							</Stack>
						</Stack> */}
						<Stack.Item style={sectionSeparator}>
							<Label styles={labelHeadingStyle}>{languageStrings.Integrations}</Label>
							<Toggle
								label={"HIX"}
								checked={newTenant.enableHix}
								onChange={(_, checked?: boolean) => setNewTenant(prevTenant => ({ ...prevTenant, enableHix: checked ?? false }))}
								onText={languageStrings.Yes}
								offText={languageStrings.No}
							/>
							{newTenant.enableHix && (
								<>
									<TextField
										label={languageStrings.Url}
										placeholder="https://tenant.hixportal.com"
										value={newTenant.hixBaseUrl}
										onChange={(_, newValue?: string) => setNewTenant(prevTenant => ({ ...prevTenant, hixBaseUrl: newValue }))}
										onGetErrorMessage={(value: string) => value?.trim()?.length > 0 && !value.trim().toLowerCase()?.startsWith("https://") ? languageStrings.InvalidUrl : ""}
										validateOnFocusOut
									/>
									<WriteOnlySecretInput
										label={"API token"}
										maskedValue={newTenant.hixApiTokenMasked}
										propertyName="hixApiToken"
										propertyValue={newTenant?.hixApiToken}
										setNewTenant={setNewTenant}
									/>
								</>
							)}
							<Toggle
								label={"Tess"}
								checked={newTenant.tessIsEnabled}
								onChange={(_, checked?: boolean) => setNewTenant(prevTenant => ({ ...prevTenant, tessIsEnabled: checked ?? false }))}
								onText={languageStrings.Yes}
								offText={languageStrings.No}
							/>
							{newTenant.tessIsEnabled && (
								<>
									<TextField
										label={languageStrings.Url}
										placeholder="https://tenant.my.salesforce.com"
										value={newTenant.tessUrl}
										onChange={(_, newValue?: string) => setNewTenant(prevTenant => ({ ...prevTenant, tessUrl: newValue }))}
										onGetErrorMessage={(value: string) => value?.trim()?.length > 0 && !value.trim().toLowerCase()?.startsWith("https://") ? languageStrings.InvalidUrl : ""}
										validateOnFocusOut
									/>
									<SecuredInput
										inputLabel={languageStrings.ClientId}
										propertyName="tessClientId"
										propertyValue={newTenant?.tessClientId}
										setNewTenant={setNewTenant}
									/>
									<WriteOnlySecretInput
										label={languageStrings.ClientSecret}
										maskedValue={newTenant.tessClientSecretMasked}
										propertyName="tessClientSecret"
										propertyValue={newTenant?.tessClientSecret}
										setNewTenant={setNewTenant}
									/>
								</>
							)}
							<Toggle
								label={languageStrings.Accountancy}
								checked={newTenant.clientListIsEnabled}
								onChange={(_, checked?: boolean) => setNewTenant(prevTenant => ({ ...prevTenant, clientListIsEnabled: checked ?? false }))}
								onText={languageStrings.Yes}
								offText={languageStrings.No}
							/>
							{newTenant.clientListIsEnabled && (
								<TextField
									label={languageStrings.Url}
									placeholder="https://tenant.sharepoint.com/sites/clients"
									value={newTenant.clientListUrl}
									maxLength={2048}
									onChange={(_, newValue?: string) => setNewTenant(prevTenant => ({ ...prevTenant, clientListUrl: newValue }))}
									onGetErrorMessage={(value: string) => value?.trim()?.length > 0 && !isValidHttpsUrl(value) ? languageStrings.InvalidUrl : ""}
									validateOnFocusOut
									validateOnLoad={false}
									onRenderLabel={(props, defaultRender) => (
										<Stack horizontal verticalAlign="center">
											{defaultRender && defaultRender(props)}
											<InfoBox title={languageStrings.Accountancy} content={languageStrings.ClientListUrlDescription} />
										</Stack>
									)}
								/>
							)}
						</Stack.Item>
						<Stack style={sectionSeparator}>
							<Label styles={labelHeadingStyle}>{languageStrings.MetadataColorsEdit}</Label>
							<Stack horizontal verticalAlign='center' horizontalAlign="space-between">
								<Label
									styles={{
										root: {
											fontWeight: FontWeights.regular,
										},
									}}
								>
									{newTenant?.metadataTextColors?.length ?? 0} {languageStrings.MetadataColorValues}
								</Label>
							</Stack>
							<div>
								<DefaultButton
									onClick={() => {
										openListPanel(TenantListSections.ColorPicker);
									}}
									style={{ marginTop: 10 }}
								>
									{languageStrings.Manage}
								</DefaultButton>
							</div>
						</Stack>
						<Stack>
							<ListToggleSection
								heading={languageStrings.SiteSettings}
								toggleLabel={languageStrings.ShowAllSites}
								numberOfFields={getFieldNumber(TenantListSections.Sites)}
								toggleSetterCallback={() => setNewTenant(prevTenant => ({ ...prevTenant, showAllSites: !prevTenant.showAllSites }))}
								toggleValue={newTenant.showAllSites ?? true}
								hasEditButton={isGlobalAdmin}
								editButtonCallback={() => {
									openListPanel(TenantListSections.Sites);
								}}
								editButtonText={languageStrings.Manage}
								mainStyle={sectionSeparator}
								readOnly={!isGlobalAdmin}
							/>
							<Label
								styles={{
									root: {
										fontWeight: FontWeights.regular,
									},
								}}
							>
								{languageStrings.SitesLibrariesConfigured.replace('{siteCount}', tenant?.sites?.length.toString() ?? '0').replace('{libraryCount}', tenantSiteLibrariesCount.toString())}
							</Label>
							<div>
								<DefaultButton
									onClick={() => {
										setIsManageSitesOpen(true);
									}}
									style={{ marginTop: 10 }}
								>
									{languageStrings.Manage}
								</DefaultButton>
							</div>
						</Stack>
						<Stack style={sectionSeparator}>
							<Label styles={labelHeadingStyle}>{languageStrings.DataSources}</Label>
							<Label
								styles={{
									root: {
										fontWeight: FontWeights.regular,
									},
								}}
							>
								{languageStrings.DatasourceNumber.replace('{number}', tenant?.datasources?.length.toString() ?? '0')}
							</Label>
							<div>
								<DefaultButton
									onClick={() => {
										setIsDataSourcePanelOpen(true);
									}}
									style={{ marginTop: 10 }}
								>
									{languageStrings.Manage}
								</DefaultButton>
							</div>
						</Stack>
					</Stack>
				</ScrollablePane>
			</div>
			<Stack horizontal horizontalAlign="end" tokens={{ childrenGap: 15 }}>
				<PrimaryButton
					styles={panelActionButtonStyle}
					disabled={newTenant.id === 0 ? (isGlobalAdmin ? !isClientListUrlValid() : true) : (isSaveDisabled || !isClientListUrlValid())}
					iconProps={{ iconName: 'save' }}
					onClick={async () => {
						setErrorMessage("");
						if (tenant?.id === 0) {
							try {
								const results = await addTenantAPI(newTenant);
								if (results.success) {
									setIsOpen(false); //close panel
									addTenant(results.tenant, false);
									closeOnAddSuccess();
								} else {
									setErrorMessage(results.message);
								}
							} catch (error) {

							}
						} else {
							updateTenant(newTenant, tenant); //local state
							setIsOpen(false); //close panel
						}
					}}
				>
					{newTenant.id === 0 ? languageStrings.Create : languageStrings.Save}
				</PrimaryButton>
				{/* {isPartner && (
					<DefaultButton
						styles={panelActionButtonStyle}
						iconProps={{ iconName: 'delete' }}
						onClick={async () => {
							setShowDeleteDialog(true);
							setIsOpen(false); //close panel
						}}
					>
						{languageStrings.Delete}
					</DefaultButton>
				)} */}
				{isGlobalAdmin && tenant.id > 0 && tenantUsers.length == 0 ? (
					<DefaultButton
						styles={panelActionButtonStyle}
						iconProps={{ iconName: 'delete' }}
						onClick={async () => {
							setShowGlobalDeleteDialog(true);
							setIsOpen(false); //close panel
						}}
					>
						{languageStrings.Delete}
					</DefaultButton>
				) : null}
			</Stack>
			{isPartnerViewListOpen && (
				<ViewListPanel
					isOpen={isPartnerViewListOpen}
					setIsOpen={setIsPartnerViewListOpen}
					text={languageStrings.SelectPartner}
					addCallback={addCallbackPartner}
					removeCallback={removeCallbackPartner}
					columns={columns}
					renderItemColumn={renderPartnerItemColumn}
					shortList={[newTenant?.partner]}
					fullList={partners}
					title={newTenant?.friendlyName}
					addText={languageStrings.Change}
					removeText={languageStrings.Remove}
					multiSelect={false}
					addTitle={languageStrings.SelectPartner}
					indicateNumbers={false}
					listSetter={setNewPartner}
					escapeAddPanelAfterAction={true}
				/>
			)}
			{isAdminViewListOpen && (
				<ViewListPanel
					isOpen={isAdminViewListOpen}
					setIsOpen={setIsAdminViewListOpen}
					text={languageStrings.SelectTenantAdmin}
					addCallback={addCallbackAdmin}
					removeCallback={removeCallbackAdmin}
					columns={columns}
					renderItemColumn={renderItemColumn}
					shortList={tenantUsers.filter((u) => u.isTenantAdmin)}
					fullList={tenantUsers.filter((u) => !u.isTenantAdmin)}
					title={newTenant?.friendlyName}
					addText={languageStrings.Add}
					removeText={languageStrings.Remove}
					multiSelect={true}
					addTitle={languageStrings.SelectTenantAdmin}
					indicateNumbers={true}
					listSetter={setNewTenantAdmins}
				/>
			)}
			{/* {isSelectPiiInfoTypesPanelOpen && <SelectPiiInfoTypesPanel tenant={tenant} isOpen={isSelectPiiInfoTypesPanelOpen} closePanel={() => setIsSelectPiiInfoTypesPanelOpen(false)} updateTenant={updateTenant} />} */}
			{/* Advanced Fields */}
			{tenantListPanels.find((panel) => panel.type == TenantListSections.AdvancedSearch)?.isOpen && <OrderedFieldsPanel
				isOpen={tenantListPanels.find((panel) => panel.type == TenantListSections.AdvancedSearch)?.isOpen}
				closePanel={() => closeListPanel(TenantListSections.AdvancedSearch)}
				title={newTenant?.friendlyName}
				subtitle={languageStrings.ManageAdvancedSearchFields}
				initialList={typeof newTenant?.allowedAdvancedSearchFields === 'string' ? Array.from([newTenant?.allowedAdvancedSearchFields]) : newTenant?.allowedAdvancedSearchFields}
				okCallback={(list) => setNewTenant({ ...newTenant, allowedAdvancedSearchFields: list })}
				type={TenantListSections.AdvancedSearch}
				showMoveButtons
			/>}
			{/* Teams Fields */}
			{tenantListPanels.find((panel) => panel.type == TenantListSections.Teams)?.isOpen && <OrderedFieldsPanel
				isOpen={tenantListPanels.find((panel) => panel.type == TenantListSections.Teams)?.isOpen}
				closePanel={() => closeListPanel(TenantListSections.Teams)}
				title={newTenant?.friendlyName}
				subtitle={languageStrings.ManageTeamsFields}
				initialList={typeof newTenant?.allowedTeams === 'string' ? Array.from([newTenant?.allowedTeams]) : newTenant?.allowedTeams}
				okCallback={(list) => {
					const updatedTenant: ITenant = { ...newTenant, allowedTeams: list }
					setNewTenant(updatedTenant);
					updateTenant(updatedTenant, tenant);
				}}
				type={TenantListSections.Teams}
			/>}
			{/* Sites Fields */}
			{tenantListPanels.find((panel) => panel.type == TenantListSections.Sites)?.isOpen && <OrderedFieldsPanel
				isOpen={tenantListPanels.find((panel) => panel.type == TenantListSections.Sites)?.isOpen}
				closePanel={() => closeListPanel(TenantListSections.Sites)}
				title={newTenant?.friendlyName}
				subtitle={languageStrings.ManageSites}
				initialList={typeof newTenant?.allowedSiteCollections === 'string' ? Array.from([newTenant?.allowedSiteCollections]) : newTenant?.allowedSiteCollections}
				okCallback={(list) => setNewTenant({ ...newTenant, allowedSiteCollections: list })}
				type={TenantListSections.Sites}
			/>}
			{/* MetaData Fields */}
			{tenantListPanels.find((panel) => panel.type == TenantListSections.MetaData)?.isOpen && <OrderedFieldsPanel
				isOpen={tenantListPanels.find((panel) => panel.type == TenantListSections.MetaData)?.isOpen}
				closePanel={() => closeListPanel(TenantListSections.MetaData)}
				title={newTenant?.friendlyName}
				subtitle={languageStrings.ManageMetaData}
				initialList={typeof newTenant?.hiddenMetadataFields === 'string' ? Array.from([newTenant?.hiddenMetadataFields]) : newTenant?.hiddenMetadataFields}

				okCallback={(list) => setNewTenant({ ...newTenant, hiddenMetadataFields: list })}
				type={TenantListSections.MetaData}
			/>}
			{/* Text Color Picker */}
			{tenantListPanels.find((panel) => panel.type == TenantListSections.ColorPicker)?.isOpen && <OrderedFieldsPanel
				isOpen={tenantListPanels.find((panel) => panel.type == TenantListSections.ColorPicker)?.isOpen}
				closePanel={() => closeListPanel(TenantListSections.ColorPicker)}
				title={newTenant?.friendlyName}
				subtitle={languageStrings?.MetaDataColorPicker}
				initialList={newTenant?.metadataTextColors?.map(item => item.value)}
				metaDataTextColors={newTenant?.metadataTextColors}
				setMetaDataTextColorsCallback={(metadataTextColors) => {
					const updatedTenant: ITenant = { ...newTenant, metadataTextColors: metadataTextColors }
					setNewTenant(updatedTenant);
				}}
				okCallback={(list) => {
					let tempNewTenant: ITenant = newTenant;
					if (Array.isArray(list) && Array.isArray(newTenant.metadataTextColors) && list.length > newTenant.metadataTextColors.length) {
						tempNewTenant = { ...newTenant, metadataTextColors: [...newTenant.metadataTextColors, { value: list[list.length - 1], hexColor: "#d4e7f6" }] }
					} else {
						const filteredTempNewTenant = tempNewTenant.metadataTextColors?.filter(item => {
							const itemValueLower = item.value.toLowerCase();
							return list.map(val => val.toLowerCase()).includes(itemValueLower);
						});
						tempNewTenant = { ...newTenant, metadataTextColors: filteredTempNewTenant ?? list?.map(listItem => ({ value: listItem, hexColor: "#d4e7f6" })) }
					}
					updateTenant(tempNewTenant, tenant);
				}}
				type={TenantListSections.ColorPicker}
			/>}
			{/* Manage advanced sites */}
			<ManageSitesPanel isOpen={isManageSitesOpen} dismissPanel={() => setIsManageSitesOpen(false)} tenant={newTenant} />
			<ColorPickerPanel
				isOpen={isColorPickerPanelOpen}
				dismissPanel={() => setIsColorPickerPanelOpen(false)}
				tenant={newTenant}
				colorChanged={(color: string) => {
					setNewTenant({ ...newTenant, appColor: color });
				}}
			/>
			{/* newTenant (in-edit copy), matching the sibling panels: the client-type fields
			    gate on tenant.clientListUrl, and the saved prop would hide them until the
			    tenant edit is saved (or keep showing them after the URL is cleared). */}
			<DataSourcePanel isOpen={isDataSourcePanelOpen} dismissPanel={() => setIsDataSourcePanelOpen(false)} tenant={newTenant} />
			{isEmailMappingPanelOpen && <EmailMappingPanel
				isOpen={isEmailMappingPanelOpen}
				emailToMetadataMapping={newTenant.emailToMetadataMapping}
				closePanel={() => setIsEmailMappingPanelOpen(false)}
				closeOnSave={(compressedData: string, clearUserEmailMappings: boolean) => {
					const updatedTenant: ITenant = { ...newTenant, emailToMetadataMapping: compressedData }
					setNewTenant(updatedTenant);
					updateTenant(updatedTenant, tenant);
					if (clearUserEmailMappings) {
						clearTenantUserEmailMappings(updatedTenant.tenantId);
					}

					setIsEmailMappingPanelOpen(false);
				}}
			/>}
		</Panel>
	);
};

export default connector(EditTenantPanel);
